import { Cotizacion } from "@/shared/types/cotizacion";
import { Moneda } from "@/shared/types/moneda";
import { TransferenciaMetodo } from "@/shared/types/transferencia-metodo";
import { createContext, PropsWithChildren, useContext, useMemo } from "react";
import { getMonedaBase } from "../shared/utils";

export interface MonetizacionContextReturn {
    cotizacion: Cotizacion,
    monedas: Moneda[],
    monedaBase: Moneda,
    transferenciaMetodos: TransferenciaMetodo[],
    transferenciaMetodoBase: TransferenciaMetodo
}

const MonetizacionContext = createContext<MonetizacionContextReturn>({
    cotizacion: null!,
    monedas: [],
    monedaBase: null!,
    transferenciaMetodos: [],
    transferenciaMetodoBase: null!
});

export function useMonetizacionContext() {
    return useContext(MonetizacionContext);
}

export interface MonetizacionProviderProps extends PropsWithChildren {
    cotizacion: Cotizacion,
    monedas: Moneda[],
    transferenciaMetodos: TransferenciaMetodo[],
}

export function MonetizacionProvider({
    cotizacion,
    monedas,
    transferenciaMetodos,
    children
}: MonetizacionProviderProps) {
    const monedaBase = useMemo(() => getMonedaBase(monedas)!, [monedas]);
    const transferenciaMetodoBase = useMemo(() => transferenciaMetodos.find(tm => tm.metodoBase)!, [transferenciaMetodos]);

    return <MonetizacionContext.Provider value={{
        cotizacion,
        monedaBase,
        monedas,
        transferenciaMetodos,
        transferenciaMetodoBase
    }}>
        {children}
    </MonetizacionContext.Provider>
}